import EntityDeleteDialog from '../../entityManagement/components/EntityDeleteDialog';
import { getSelectedAddressLine1 } from '../selectors';
import { deleteAddress } from '../actions';
import { createDeleteDialogConnect } from '../../entityManagement';

export default createDeleteDialogConnect(getSelectedAddressLine1, deleteAddress)(EntityDeleteDialog);
